module.exports = __webpack_public_path__ + "static/media/watch1.12300651.jpg";